import React, { useState } from 'react';
import './Colocation.css';

const Colocation = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: '۱U',
      price: '۴۰۰',
      unit: 'هزار تومان / ماه',
      power: '۱ آمپر',
      bandwidth: '۱ گیگابیت',
      features: ['فضای رک ۱U', 'برق و خنک‌کننده', 'پهنای باند اختصاصی', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: '۲U',
      price: '۶۰۰',
      unit: 'هزار تومان / ماه',
      power: '۲ آمپر',
      bandwidth: '۲ گیگابیت',
      features: ['فضای رک ۲U', 'برق و خنک‌کننده', 'پهنای باند اختصاصی', 'پشتیبانی ۲۴/۷', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: '۴U',
      price: '۱,۰۰۰',
      unit: 'هزار تومان / ماه',
      power: '۴ آمپر',
      bandwidth: '۵ گیگابیت',
      features: ['فضای رک ۴U', 'برق و خنک‌کننده', 'پهنای باند اختصاصی', 'پشتیبانی ۲۴/۷', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>کلوکیشن سرور | خدمات کلوکیشن در ایران و هلند | افراسل</h1>
        <p>خدمات کلوکیشن سرور در دیتاسنترهای ایران و هلند با بهترین قیمت و پشتیبانی ۲۴ ساعته.</p>
        <meta name="description" content="خدمات کلوکیشن سرور در ایران و هلند با بهترین قیمت از افراسل. فضای رک، برق، خنک‌کننده و پشتیبانی ۲۴/۷." />
      </div>

      <section className="colocation-hero">
        <div className="colocation-hero-bg"></div>
        <div className="wrap">
          <div className="colocation-hero-content">
            <div className="colocation-badge">
              <span className="pulse-dot"></span>
              🏢 کلوکیشن سرور
            </div>
            <h1 className="colocation-hero-title">
              خدمات <em>کلوکیشن</em>
            </h1>
            <p className="colocation-hero-desc">
              خدمات کلوکیشن سرور در دیتاسنترهای معتبر ایران و هلند.
              فضای رک، برق، خنک‌کننده و پهنای باند اختصاصی با بهترین قیمت.
            </p>
            <div className="colocation-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">ایران/هلند</span>
                <span className="stat-label">لوکیشن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="colocation-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های کلوکیشن</span>
            <h2 className="sec-h">پلن <em>مناسب</em> نیاز خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع کلوکیشن با قیمت‌های رقابتی.</p>
          </div>
          <div className="colocation-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`colocation-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="colocation-popular-badge">پرفروش‌ترین</span>}
                <div className="colocation-plan-tier">{plan.tier}</div>
                <div className="colocation-plan-price">
                  <span className="colocation-plan-num">{plan.price}</span>
                  <span className="colocation-plan-unit">{plan.unit}</span>
                </div>
                <div className="colocation-plan-specs">
                  <div><span>⚡</span> {plan.power}</div>
                  <div><span>🌐</span> {plan.bandwidth}</div>
                </div>
                <ul className="colocation-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="colocation-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="colocation-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              خدمات <em>کلوکیشن</em> را همین حالا سفارش دهید
            </h2>
            <p className="cta-desc">
              با استفاده از خدمات کلوکیشن افراسل، سرورهای خود را در بهترین دیتاسنترها قرار دهید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>سفارش کلوکیشن</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Colocation;
